import { MediaUploadButton, UPLOADER_TYPE } from '@project/components'
import React from 'react';
import axiosInstance, { CancelToken } from '../../utils/axios'
import { getNestedElement } from '../../utils/utils';

const SpaceProfilePhotoUpload = ({ guid, fieldKey, spaceProfilePhotos, setSpaceProfilePhotos, isReadOnly }) => {
  if (!spaceProfilePhotos?.basic_info) return null;
  const onUpdate = (updatedFiles) => {
    const updatedPhotoField = getNestedElement(spaceProfilePhotos, fieldKey);
    if (!updatedPhotoField) return;

    updatedPhotoField.files = updatedFiles;

    setSpaceProfilePhotos(Object.assign(
      {},
      {...spaceProfilePhotos}
    ))
  }

  const photos = getNestedElement(spaceProfilePhotos || {}, `${fieldKey}.files`) || [];

  return (
    <MediaUploadButton
      className="ml-2"
      axiosInstance={axiosInstance}
      axiosCancelTokenFactory={CancelToken}
      uploadRoute={`/space-profiles/${guid}/files`}
      deleteRoute={`/space-profiles/${guid}/files`}
      media={photos}
      onUpdate={onUpdate}
      extraPayloadData={{ fieldKey }}
      title={'Photos'}
      type={UPLOADER_TYPE.IMAGE}
      readOnly={isReadOnly}
    />
  );
}

export default SpaceProfilePhotoUpload;
